import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const FormFeedback = ({ children, className, innerRef, ...rest }) => (
  <div className={classnames('text-red font-12 mt-5', className)} data-testid="FormFeedback" ref={innerRef} {...rest}>
    {children}
  </div>
);

FormFeedback.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
};

FormFeedback.defaultProps = {
  children: null,
  className: null,
  innerRef: null,
};

export default FormFeedback;
